import { isEn } from "./i18n";
// トップページの大会検索。キーワード（大会名・会場・種目）・種目・開催月で絞り込む
export interface Searchable { name: string; venue: string; disciplines: string[]; start: Date; close: Date }
export interface Filter { q: string; discipline: string; month: string } // month は "YYYY-MM"、空なら条件なし

const norm = (s: string) => s.normalize("NFKC").toLowerCase().replace(/\s+/g, "");
const ym = (d: Date) => { const j = new Date(d.getTime() + 9 * 3600_000); return `${j.getUTCFullYear()}-${String(j.getUTCMonth() + 1).padStart(2, "0")}`; };

export function matches(e: Searchable, f: Filter): boolean {
  if (f.discipline && !e.disciplines.includes(f.discipline)) return false;
  if (f.month && ym(e.start) !== f.month) return false;
  const words = norm(f.q) ? f.q.normalize("NFKC").toLowerCase().split(/\s+/).filter(Boolean) : [];
  const hay = norm([e.name, e.venue, ...e.disciplines].join(" "));
  return words.every((w) => hay.includes(norm(w)));
}

// 締切が now から days 日以内の大会を、締切の早い順に返す
export function closingSoon<T extends Searchable>(list: T[], now: Date, days = 7): T[] {
  const limit = now.getTime() + days * 86_400_000;
  return list.filter((e) => e.close.getTime() >= now.getTime() && e.close.getTime() <= limit).sort((a, b) => a.close.getTime() - b.close.getTime());
}

// 開催月の選択肢（日本時間）。重複を除いて早い順
export function monthOptions(list: Searchable[]): { value: string; label: string }[] {
  return [...new Set(list.map((e) => ym(e.start)))].sort().map((v) => ({ value: v, label: isEn() ? `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][Number(v.slice(5)) - 1]} ${v.slice(0, 4)}` : `${Number(v.slice(0, 4))}年${Number(v.slice(5))}月` }));
}
